import { useEffect } from "react"

import { AFTER_FOOTER } from "components/Footer/components/AfterFooter/constants"
import { CreatePortalAfterComponent, Layout } from "components"
import { Analytics } from "utils/analytics"
import { PaymentProvider } from "modules/Payment/PaymentContext"

export function Payment() {
    useEffect(() => {
        Analytics.successful_booking_page_shown()
    }, [])

    return (
        <Layout>
            <CreatePortalAfterComponent idPortalName={AFTER_FOOTER}>
                <PaymentProvider />
            </CreatePortalAfterComponent>
        </Layout>
    )
}
